import { InjectionKey } from 'vue'
import type { RichTextOptions } from './richtext'
import { BlokMainComponent } from './composables-interfaces'
import { DownloadButtonOptions } from './download-button'

export const richTextOptions = Symbol() as InjectionKey<RichTextOptions>
export const blokMainComponent = Symbol() as InjectionKey<BlokMainComponent | undefined>
export const downloadBtnOptions = Symbol() as InjectionKey<DownloadButtonOptions>
